import React, { Component } from 'react';
import { IoMdSearch } from 'react-icons/io';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import Input from '../../components/Input';
import ListPesquisadores from '../../components/ListPesquisadores';
import ModalRemover from '../../components/ModalRemover';
import { getLink } from '../../services/host';

import './style.css';
import Button from '../../components/Button';

class InstitucionalDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      busca: '',
      modal: null,
    };
  }

  componentDidMount() {
    document.title = `Dashboard - Institucional`;
    window.scrollTo(0, 0);

    this.iniciaMicrofone();
  }

  iniciaMicrofone() {
    try {
      if (navigator.mediaDevices.getUserMedia !== null) {
        var options = {
          video: false,
          audio: true,
        };
        navigator.mediaDevices
          .getUserMedia(options)
          .then((stream) => {
            //para stream
            stream.getTracks().forEach((x) => x.stop());
          })
          .catch((err) => {
            this.setState({
              modal: (
                <ModalRemover
                  onClick={() => this.setState({ modal: null })}
                  onlymessage={true}
                  message="É preciso dar permissão ao microfone para continuar"
                />
              ),
            });
          });
      } else {
        this.setState({
          modal: (
            <ModalRemover
              onClick={() => this.setState({ modal: null })}
              onlymessage={true}
              message="Nenhum microfone encontrado ou seu navegador não tem permissão para acessa-lo."
            />
          ),
        });
      }
    } catch (e) {
      this.setState({
        modal: (
          <ModalRemover
            onClick={() => this.setState({ modal: null })}
            onlymessage={true}
            message="Nenhum microfone encontrado ou seu navegador não tem permissão para acessa-lo."
          />
        ),
      });
    }
  }

  render() {
    return (
      <div id="institucional-dashboard">
        <Header />

        <div className="content">
          <TopPage
            title="APLICADORES"
            add={getLink(`/cadastrar-pesquisador`)}
            textAdd="Adicionar novo"
          />

          <Input
            placeholder="Buscar aplicador"
            name="pesquisador"
            id="pesquisador"
            button={true}
            onChange={(e) => {
              this.setState({ busca: e.target.value });
            }}
          >
            <Button>
              <IoMdSearch />
            </Button>
          </Input>

          <ListPesquisadores pesquisadores={true} busca={this.state.busca} />
        </div>

        <Footer />

        {this.state.modal}
      </div>
    );
  }
}

export default InstitucionalDashboard;
